export default __webpack_public_path__ + "static/media/mongo1.479432de.png";